import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { CreateStreamPopup } from 'APP/main/PopupManager/Popups/CreateStreamPopup/CreateStreamPopup';
import Entities from 'STORE';

export async function openCreateStreamPopup(groupId: string): Promise<boolean> {
  if (Entities.Calls.ongoingCall || Entities.ActiveStream.hasStream) {
    Tasks.app.showAlert(t('calls_join_another_call'));
    return false;
  }

  const hasAudioPermission = await Tasks.permissions.hasMicrophonePermission();
  if (!hasAudioPermission) {
    return false;
  }

  Tasks.app.openPopup(CreateStreamPopup, { params: { groupId } });

  return true;
}
